export default [
  {
    path: '/main/reports',
    meta: {
      tag: 'reports',
      name: 'Relatórios',
      breadcrumb: 'Relatórios'
    },
    component: () => import(/* webpackChunkName: "reports" */ '@/views/main/reports/Index.vue'),
  }
]  